import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { trackEvent, breakpoint, matchesMediaQuery } from '@offerzen/pinata-shame'

class ReapplyTracking extends Component {
  static propTypes = {
    children: PropTypes.func,
  }

  render() {
    const { children, ...rest } = this.props
    return children(rest)
  }
}

const mapStateToProps = state => ({
  candidateId: state.candidate.id,
})

const mapDispatchToProps = () => ({
  trackReapplyModal: (action, source) =>
    trackEvent('Candidate: reapply', {
      action,
      source,
    }),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  trackReapplyModal: action => {
    dispatchProps.trackReapplyModal(action, !matchesMediaQuery(breakpoint.phone) ? 'mobile' : 'desktop')
  },
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ReapplyTracking)
